import React from 'react';
import { Helmet } from 'react-helmet-async'; // Add this import for SEO
import Stats from '../../../components/Global/BannerCard/Stats/Stats';
import LIRC from '../../../components/Global/BannerCard/LIRC/LIRC';
import ExpertiseSection from '../../../components/Global/BannerCard/Expertise/ExpertiseSection';
import THC from '../../../components/Global/BannerCard/T&HC/THC';
import MakeTheShift from '../../../components/MakeTheShift/MakeTheShift';
import CyientGrid from '../../../components/Global/BannerCard/CyientGrid/CyientGrid';
import ContactPage from '../../../components/Global/BannerCard/DynamicHeader/ContactPage1';

const HealthCareLifeSciences = () => {
  const canonicalUrl = `${process.env.REACT_APP_BASE_URL || 'https://www.adithyainfinity.com'}/healthcare-lifesciences`;

  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>
          Aerospace & Defense | Intelligent Engineering & Manufacturing Solutions | V Adithya Infinity Pvt Ltd
        </title>
        <meta
          name="description"
          content="Delivering intelligent engineering and manufacturing solutions in Aerospace & Defense. Explore cutting-edge innovations and sustainable practices."
        />
        <meta
          name="keywords"
          content="aerospace engineering, defense manufacturing, intelligent engineering solutions, V Adithya Infinity, aerospace innovation, defense technology"
        />
        <link rel="canonical" href={canonicalUrl} />

        {/* Open Graph tags */}
        <meta property="og:title" content="Aerospace & Defense | Intelligent Engineering & Manufacturing Solutions | V Adithya Infinity Pvt Ltd" />
        <meta
          property="og:description"
          content="Delivering intelligent engineering and manufacturing solutions in Aerospace & Defense."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta
          property="og:image"
          content="https://www.adithyainfinity.com/assets/images/aerospace-defense-banner.jpg"
        />

        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Aerospace & Defense | Intelligent Engineering & Manufacturing Solutions | V Adithya Infinity Pvt Ltd" />
        <meta
          name="twitter:description"
          content="Delivering intelligent engineering and manufacturing solutions in Aerospace & Defense."
        />
        <meta
          name="twitter:image"
          content="https://www.adithyainfinity.com/assets/images/aerospace-defense-banner.jpg"
        />
      </Helmet>

      <div>
        <ContactPage
          title="AEROSPACE & DEFENSE"
          subTitle="Delivering intelligent engineering and manufacturing solutions."
          backgroundImage="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBw8NDw0NDQ0QDQ0NEBINDQ0NEBANDQ0NFRIWFhURFRUYHSggGBolGxUVITEhJSkrOi4uFx8/OD84Nyg5OisBCgoKDg0NFQ0NFSsZFRkrLS03LSsrKy03Ny0rKystLS03LS0rNy0tLS0tNysrLTc3Ny0tNystKy03Ny0tKy0tK//AABEIAKgBLAMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAAAAQIHA//EACYQAQAABQUAAgMBAQEAAAAAAAADMdHh8AIUQVOSARFRYcGhsSH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AOIAKKACoAigApZFsAAC3LJfktyC3Vm/LWTAuJfkr+QU+/8Av8TJrX8/oEVMmZMD7/gnxn/pkwLFyxcAABAARUAAFQBAAAAUURQAMmCiZMyYirbhMmW5BS3Bky3IBbgyZbkFvwJflcmBklyTOTWv5AyS1/jOTWv5/QGSEyZkwW3CZItyZMC3BfgtyX5AQyZkwATJgqGTBT5D5QABABAUAFEVQABRARSwW5BSxk0tyCljJluQLr9pfkyYH2qZMyYC5/iZMyf6ADJmTAsFuTJgWLluUvyCoZMyYAICoAoCIAAAICgAAAoCioAKBbkQWyZMyYKJk1yYFxL8rkwBMmuTAM/xMmuTAEya5MCwmTMmC5JDJmTADJgCAKAAICAACAAoAAAKIKKAClkAUQEUEBbqyoKIAKgAqAAAAgCoAoAAIAAIAIAioDQn2AoCgAgogCgKKgAomTAFQEUTJgKIuTAEyagCAAZMFAAEVEFQFAABPtUQQABftAGkAFAAABRAFEUAD7UFQAVAAABUAAAAQFQAAEAEBU+w+wPtAAAAABfg+EX4BRPgBRBRQEBUFFEEFEFFEEFEFFEEFEAAAAAAQFD7T7A+flFQAAAAAAAAFEAVWVBRFAAAAAAAAAAAAAAAAABAVBAUQAAAAABAURQAAAAAAFQBVZUFEAURfkARQBFAE+AFEAAAEAFQAAAAAAQAAHvs4vTE8aqGzi9MTxqoAGzi9MTxqouzi9MTxqogC7OL1RPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9UTxqogC7OL1RPGqibOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAP/9k="
          highlightWord="DEFENSE"
        />
        <Stats />
        <LIRC />
        <CyientGrid />
        <ExpertiseSection />
        <THC />
        <MakeTheShift />
      </div>
    </>
  );
};

export default HealthCareLifeSciences;
